import { LookupCodes } from 'src/constants/lookup.constants';
import { GroupedImageToolOptions } from '../base-toolbar/toolbar-options/tool-options-renderer/grouped-image-tool/GroupedImageToolOptions';
import { AvailableToolsMap } from '../base-toolbar/BaseToolbar.types';
import { EDIT_TOOLS } from '../base-toolbar/BaseToolbar.constants';
import { AdjustmentToolOptions } from '../base-toolbar/toolbar-options/tool-options-renderer/adjustment-tool/AdjustmentToolOptions';

export const AVAILABLE_EDIT_TOOLS: AvailableToolsMap = {
  [EDIT_TOOLS.frame]: {},
  [EDIT_TOOLS.filters]: {
    ToolOptionsRenderer: GroupedImageToolOptions,
  },
  [EDIT_TOOLS.adjustments]: {
    ToolOptionsRenderer: AdjustmentToolOptions,
  },
  [EDIT_TOOLS.replace]: {},
  [EDIT_TOOLS.orientation]: {},
  [EDIT_TOOLS.restore]: {},
  [EDIT_TOOLS.undo]: {},
  [EDIT_TOOLS.redo]: {},
};

export const getAvailableEditTool = (key: string | undefined) => {
  return typeof key === 'string' ? AVAILABLE_EDIT_TOOLS[key as LookupCodes] : undefined;
};
